@if(reportGame().length > 0) {
  @for (match of reportGame(); track match.match_id) {
    <div class="games-card match-card">
      <div class="match-logo">
        <img class="profile-image" [src]="getProfileSrc(match)"/>
      </div>
      <div class="match-details">
        <div class="match-team">
          <div class="team1" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1)">{{ match.team_1_name }}</div>
          <div class="team2" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_2)">{{ 'games.report.vs' | translate }} {{ match.team_2_name }}</div>
        </div>
        <div class="match-score">Record: {{ match.team_1_score }} - {{ match.team_2_score }}</div>
      </div>
      <div class="match-buttons">
        @if(!match.score_edited_by || match.score_edited_by == user.user_id || this.currentUserTeamIds().includes(match.author_team_id)) {
          <button nbButton outline size="tiny" status="primary" (click)="openReportGameForm(match)">{{ 'games.report.report_score' | translate }}</button>
          @if(match.team_1_score && match.team_2_score) {
            <nb-icon class="pointer ml-5" (click)="openScreenshotsGallery(match)" icon="camera-outline" [nbPopover]="'games.report.display_screenshots' | translate" nbPopoverTrigger="hover" status="warning"></nb-icon>
          }
        }
      </div>
    </div>
  }
}
@else {
  <div class="no-data">{{ 'games.report.no_confirmed_match' | translate }}</div>
}
